<app-core-sidebar-header/>
@if (this.items()) {
  <app-core-sidebar-content class="mat-title-small" [items]="this.items()!"/>
}
<div class="button__collapse" (click)="toggleCollapsed()">
  <ogs-m3-icon class="icon" [icon]="isCollapsed ? 'chevron-right': 'chevron-left'"/>
</div>
